<template>
  <div>
    <title-block :id="'bm'+titles[21].label" v-if="titles[21].num && activeInfo">
      <template slot="title">{{titles[21].label}}</template>
      <div class="mt-10">
        <el-table :data="bidData" :header-cell-style="{background: '#fafafa',color: '#333'}" tooltip-effect="light">
          <el-table-column label="序号" align="center" width="50">
            <template slot-scope="{$index}">
              <span>{{$index+1}}</span>
            </template>
          </el-table-column>
          <el-table-column label="发布时间" align="center" show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.pubDate}}</span>
            </template>
          </el-table-column>
          <el-table-column label="公告名称" align="center" show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.announcementName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="信息分类" align="center" show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.infoType}}</span>
            </template>
          </el-table-column>
          <el-table-column label="地区" align="center" show-overflow-tooltip>
            <template slot-scope="{row}">
              <span>{{row.provinceName}}{{row.cityName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" show-overflow-tooltip>
            <template slot-scope="{row}">
              <el-link type="primary" @click="showDetail(row)">详情</el-link>
            </template>
          </el-table-column>
        </el-table>
        <pagination :pageNum="titles[21].pageNum" :total="titles[21].total" @currentChange="getTenderPage" />
      </div>
    </title-block>
    <DialogBidDetail v-if="dialogShow !== null" :data="currentBidData" :show.sync="dialogShow" />

    <!-- 招聘详情 -->
    <recruitmentMsg v-if="activeInfo" :activeInfo="activeInfo" :tabsInfo="titles.slice(0,1)" @pageTurn="val => handleCurrentChange(val, 0)" />

    <!-- 行政许可 -->
    <template v-for="(item,i) in titles">
      <title-block :key="i" :id="'bm'+item.label" v-if="i>=1 && i<9 && item.num && activeInfo">
        <template slot="title">{{item.label}}</template>
        <div class="mt-10">
          <el-table :data="tableDatas(item.moduleId)" :header-cell-style="{background: '#fafafa',color: '#333'}" tooltip-effect="light">
            <template v-for="(item1, j) in tableFields(item.moduleId)">
              <el-table-column v-if="item1.field != 'rk'" :key="j" :label="item1.fieldName" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="whichType(scope.row[j])==='string'">{{columnValue(scope.row[j], item.moduleId)}}</span>
                  <span v-else-if="whichType(scope.row[j])==='object'">{{columnValue(scope.row[j], item.moduleId)}}</span>
                  <span v-else-if="whichType(scope.row[j])==='img'"><img style="width:64px" :src="columnValue(repliceHttps(scope.row[j]), item.moduleId)" alt="" srcset=""></span>
                  <span v-else-if="whichType(scope.row[j])==='url'"><a :href="columnValue(scope.row[j], item.moduleId)" style="color:#409EFF" target="_blank"
                      rel="noopener noreferrer">{{scope.row[j]}}</a></span>
                  <span v-else>{{ columnValue(scope.row[j], item.moduleId) || '--' }} </span>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <pagination :pageNum="tablePage(item.moduleId)" :total="tableTotal(item.moduleId)" @currentChange="val => handleCurrentChange(val, i)" />
        </div>
      </title-block>
    </template>

    <!-- 主营产品 -->
    <title-block :id="'bm'+titles[9].label" v-if="titles[9].num">
      <template slot="title">{{titles[9].label}}</template>
      <div class="mt-10 mainProducts" style="margin-top:24px">
        <i class="qhicon" @click="switchDisplay"><img src="~@/assets/wordqhuan.svg" alt="" /></i>
        <div class="my-kw-echarts" v-show="switchDiaplayFlag">
          <div id="zxKeywordsCloud" :style="{width: '100%', height: '400px'}"></div>
        </div>
        <div class="mainProductsWordsBox" v-show="!switchDiaplayFlag">
          <p>{{mainProductsWords}}</p>
        </div>
      </div>
    </title-block>

    <!-- 商品数据 -->
    <title-block :id="'bm'+titles[10].label" v-if="titles[10].num && activeInfo">
      <template slot="title">{{titles[10].label}}</template>
      <div class="mt-10 clearfix" style="margin-top:24px">
        <ul class="product-list clearfix">
          <li v-for="(item,index) in tableDatas(titles[10].moduleId)" :key="index">
            <div :class="['img',item[0]?'':'defalutImg']">
              <img v-if="item[0]" :src="item[0]" />
              <img v-else src="~@/assets/defalut-img.png" />
            </div>
            <p class="textOverflow" :title="item[1]">{{item[1]}}</p>
          </li>
        </ul>
        <pagination :pageNum="tablePage(titles[10].moduleId)" :pageSize="3" :total="tableTotal(titles[10].moduleId)" @currentChange="val => handleCurrentChange(val, 10)" />
      </div>
    </title-block>

    <template v-for="(item,i) in titles">
      <title-block :key="i" :id="'bm'+item.label" v-if="i>=11 &&i<=15 && item.num && activeInfo">
        <template slot="title">{{item.label}}</template>
        <div class="mt-10">
          <el-table :data="tableDatas(item.moduleId)" :header-cell-style="{background: '#fafafa',color: '#333'}" tooltip-effect="light">
            <el-table-column v-if="i == 7 || i == 10" type="index" label="序号" align="center" width="70" />
            <template v-for="(item1, j) in tableFields(item.moduleId)">
              <el-table-column v-if="item1.field != 'rk'" :key="j" :label="item1.fieldName" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <template v-if="item1.fieldName == '二维码'">
                    <span v-if="isEmpty(scope.row[j])">--</span>
                    <el-popover v-else placement="left" popper-class="auto-width" trigger="hover" width="auto">
                      <img :src="scope.row[j]" class="qrcode-img" />
                      <img class="qr-code-holder" slot="reference" src="/static/image/qrcode.png" />
                    </el-popover>
                  </template>
                  <template v-else>
                    <span v-if="whichType(scope.row[j])==='string'">{{columnValue(scope.row[j], item.moduleId)}}</span>
                    <span v-else-if="whichType(scope.row[j])==='object'">{{columnValue(scope.row[j], item.moduleId)}}</span>
                    <span v-else-if="whichType(scope.row[j])==='img'"><img style="width:100%;max-width:64px;" :src="columnValue(repliceHttps(scope.row[j]), item.moduleId)" alt="" srcset=""></span>
                    <span v-else-if="whichType(scope.row[j])==='url'"><a :href="scope.row[j]" target="_blank" rel="noopener noreferrer">{{columnValue(scope.row[j], item.moduleId)}}</a></span>
                    <span v-else>{{ columnValue(scope.row[j], item.moduleId) || '--' }} </span>
                  </template>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <pagination :pageNum="tablePage(item.moduleId)" :total="tableTotal(item.moduleId)" @currentChange="val => handleCurrentChange(val, i)" />
        </div>
      </title-block>
    </template>

    <!-- 建站网站 -->
    <title-block id="bm建站网站" v-if="titles[16].num && activeInfo">
      <template slot="title">{{titles[16].label}}</template>
      <div class="tables mt-10" style="margin-top:16px">
        <el-table :data="tableDatas(titles[16].moduleId)" :header-cell-style="{background: '#fafafa',color: '#333'}" tooltip-effect="light">
          <el-table-column type="index" label="序号" align="center" width="70" />
          <template v-for="(item, i) in tableFields(titles[16].moduleId)">
            <el-table-column v-if="item.field != 'rk'" :key="i" :label="item.fieldName" align="center" show-overflow-tooltip>
              <template slot-scope="scope">
                <a class="textOverflow" style="width:100%;color:#409eff" rel="noopener noreferrer" v-if="item.field == 'homeUrl'" :underline="false"
                  :href="addUrl3W(columnValue(scope.row[i], titles[16].moduleId))" target="_blank">{{ addUrl3W(columnValue(scope.row[i], titles[16].moduleId))}}</a>
                <span v-else>{{ columnValue(scope.row[i], titles[16].moduleId)}}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <pagination :pageNum="titles[16].pageNum" :total="tableTotal(titles[16].moduleId)" @currentChange="val => handleCurrentChange(val, 16)" />
      </div>
    </title-block>

    <!--  :tabsInfo="tabs[activeName-1].children" :activeInfo="activeInfo" @setTitle="setTitles" @pageTurn="companyDetailBatchV2" -->
    <businessBox v-if="activeInfo" :activeInfo="activeInfo" :tabsInfo="titles.slice(17,21)" @pageTurn="handleCurrentChange" />

    <!-- <Bidding v-if="titles.slice(22,23).num" :activeInfo="activeInfo" :tabsInfo="titles.slice(22,23)" @pageTurn="handleCurrentChange"/> -->


  </div>
</template>

<script>
import mixin from '../mixins/enterpriseTabs'
import 'echarts-wordcloud';
import { mainProductWord, tenderPage, newsCluePage } from '../api/newClueApi'
import businessBox from '@/views/clue/components/businessBox'
import recruitmentMsg from '@/views/clue/components/recruitmentMsg'
import Bidding from './bidding.vue'
import DialogBidDetail from './dialogBidDetail.vue'
export default {
  mixins: [mixin],
  components: { businessBox, recruitmentMsg, Bidding, DialogBidDetail },
  name: 'Manage',
  data() {
    return {
      name: this.$route.query.name,
      mainProductsWords: '',
      switchDiaplayFlag: true,
      titles: [
        { type: '', label: '招聘详情', num: 0, moduleId: '', pageNum: 1 },

        { type: '', label: '行政许可', num: 0, moduleId: '' },
        { type: '', label: '双随机抽查', num: 0, moduleId: '' },
        { type: '', label: '进出口信用', num: 0, moduleId: '' },
        { type: '', label: '购地信息', num: 0, moduleId: '' },
        { type: '', label: '抽查检查', num: 0, moduleId: '' },
        { type: '', label: '税务评级', num: 0, moduleId: '' },
        { type: '', label: '一般纳税人', num: 0, moduleId: '' },

        { type: '', label: '产品信息', num: 0, moduleId: '' },

        { type: '', label: '主营产品', num: 0, moduleId: '' },
        { type: '', label: '商品数据', num: 0, moduleId: '', pageNum: 1 },

        // --11
        { type: '', label: '微信小程序', num: 0, moduleId: '' },
        { type: '', label: '微信公众号', num: 0, moduleId: '' },
        { type: '', label: '新浪微博', num: 0, moduleId: '' },
        { type: '', label: '蓝V账号', num: 0, moduleId: '' },
        { type: '', label: '网店信息', num: 0, moduleId: '' },
        // --

        { type: '', label: '建站网站', num: 0, moduleId: '', pageNum: 1 },
        // businessBox-
        { type: '', label: '网站基本信息', num: 0, moduleId: '' },
        { type: '', label: '网络推广', num: 0, moduleId: '' },
        { type: '', label: '平台权重', num: 0, moduleId: '' },
        { type: '', label: '收录情况', num: 0, moduleId: '' },

        { type: '', label: '招投标', num: 0, moduleId: '', total: 0, pageNum: 1 },
      ],

      // emit的时候，新的顺序
      titlesMap:{
        0: 1,
        1: 2,
        2: 3,
        3: 4,
        4: 5,
        5: 6,
        6: 7,
        7: 8,
        8: 9,
        9: 10,
        10: 11,
        11: 12,
        12: 13,
        13: 14,
        14: 15,
        15: 16,
        16: 17,
        17: 18,
        18: 19,
        19: 20,
        20: 21,
        21: 0,
      },
      bidData: [],
      dialogShow: null,
      currentBidData: null
    }
  },
  watch: {
    'titles.21.num': {
      deep: true,
      immediate: true,
      handler: function (val) {
        val && this.getTenderPage()
      }
    },
  },
  inject: ['$companyStatus'],
  mounted() {
    this.getMainProductWord()
  },
  methods: {
    showDetail(data) {
      this.currentBidData = data
      this.dialogShow = true
    },
    isEmpty(val) {
      return !val || val == '' || val == '-' || val == '--' || val == 'null'
    },
    switchDisplay() {
      this.switchDiaplayFlag = !this.switchDiaplayFlag
    },
    async getTenderPage(pageNum = 1) {
      const { data, code } = await tenderPage({ hid: this.$companyStatus.hid, pageNum })
      if (code == 200 && data) {
        this.bidData = data.newsList
        this.titles[21].total = data.total
        this.titles[21].pageNum = pageNum
      }
    },
    async getMainProductWord() {
      const { data, code } = await mainProductWord({ hid: this.$companyStatus.hid })
      if (code == 200 && data.length) {
        this.titles[9].num = data ? data.length : 0
        let arrWord = []
        let wordData = []
        data.forEach(vv => {
          arrWord.push(vv.name)
        });
        this.mainProductsWords = arrWord.join('、')
        this.$nextTick(() => {
          this.initEchart(data)
        })
      }
    },
    initEchart(wordData) {
      // document.getElementById('zxKeywordsCloud').removeAttribute('_echarts_instance_');
      let echartDom = document.getElementById('zxKeywordsCloud')
      let myChart = this.$echarts.init(echartDom)
      let color = ['#5088FF', '#000000', '#999999', '#666666']
      let option = {
        series: [{
          type: 'wordCloud',
          // shape: 'pentagon',
          // keepAspect: false,
          // maskImage: maskImage,
          left: 'center',
          top: 'center',
          width: '100%',
          height: '100%',
          right: null,
          bottom: null,
          sizeRange: [12, 24],
          rotationRange: [0, 0],
          // rotationStep: 45,
          gridSize: 14,
          // textPadding: 100,
          drawOutOfBound: false,//是否允许词云在边界外渲染
          layoutAnimation: true,//布局的时候是否有动画 为false词典过度会阻塞
          shrinkToFit: true,
          textStyle: {
            normal: {
              fontFamily: 'sans-serif',
              // fontWeight: 'bold',
              color: function () {
                return 'rgb(' + [
                  Math.round(Math.random() * 200),
                  Math.round(Math.random() * 255),
                  Math.round(Math.random() * 255)
                ].join(',') + ')';
              }
            }
          },
          //data属性中的value值却大，权重就却大，展示字体就却大
          data: wordData
        }]

      }
      option && myChart.setOption(option)
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    }
  }
}
</script>
<style lang='scss' scoped>
/deep/ .el-table th > .cell {
  font-size: 12px;
  font-weight: 400;
}
/deep/ .el-table th {
  padding: 10px 0;
  line-height: 16px;
}
/deep/ .el-table .cell {
  font-size: 12px;
  font-weight: 400;
  span {
    font-size: 12px;
  }
}

.mainProducts {
  position: relative;
  .qhicon {
    position: absolute;
    right: 0;
    top: -16px;
    z-index: 2;
    cursor: pointer;
  }
  .mainProductsWordsBox {
    border: 1px solid rgba(187, 190, 202, 0.5);
    padding: 14px 16px;
    box-sizing: border-box;
    height: 290px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
    p {
      font-weight: 400;
      color: #666666;
      line-height: 24px;
    }
  }
  .mainProductsWordsBox {
    margin-right: 40px;
  }
}
</style>
